if (!customElements.get('crownwell-cart-discount')) {
  customElements.define(
    'crownwell-cart-discount',
    class CrownwellCartDiscount extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="discount"]');
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[role="status"]');
        this.form?.addEventListener('submit', this.applyDiscount.bind(this));
      }

      async applyDiscount(event) {
        event.preventDefault();
        const code = this.input?.value.trim();

        if (!code) {
          this.showStatus('Enter a discount code first.', true);
          this.input?.focus();
          return;
        }

        this.button.disabled = true;
        this.button.textContent = 'Applying';
        this.showStatus('Checking your code…');

        try {
          const root = window.Shopify?.routes?.root || '/';
          const discountUrl = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root}cart`)}`;
          const response = await fetch(discountUrl, {
            method: 'GET',
            credentials: 'same-origin',
            redirect: 'follow',
            headers: { Accept: 'text/html' },
          });

          if (!response.ok) throw new Error('Discount request failed');

          this.showStatus(`“${code.toUpperCase()}” saved. Eligible savings will appear at checkout.`);
          this.button.textContent = 'Applied';
          this.input.setAttribute('readonly', 'readonly');

          const cartForm = document.getElementById('CartDrawer-Form');
          if (cartForm && !cartForm.querySelector('input[data-crownwell-discount]')) {
            const hiddenDiscount = document.createElement('input');
            hiddenDiscount.type = 'hidden';
            hiddenDiscount.name = 'discount';
            hiddenDiscount.value = code;
            hiddenDiscount.dataset.crownwellDiscount = 'true';
            cartForm.appendChild(hiddenDiscount);
          }
        } catch (error) {
          this.showStatus('We could not apply that code. Check it and try again.', true);
          this.button.disabled = false;
          this.button.textContent = 'Apply';
        }
      }

      showStatus(message, isError = false) {
        if (!this.status) return;
        this.status.hidden = false;
        this.status.textContent = message;
        this.status.classList.toggle('is-error', isError);
      }
    },
  );
}
